import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { ChartBarIcon, CheckIcon } from '@heroicons/react/24/solid';
import { capitalize, classNames } from '../utils';
import Button from './Common/Button';

export type AnalyticsTypeOption = 'device' | null;

export interface Props {
  analyticsTypeOptions: AnalyticsTypeOption[];
  analyticsType: AnalyticsTypeOption;
  onChange: (analyticsType: AnalyticsTypeOption) => void;
}

export const AnalyticsTypeButton = ({
  analyticsTypeOptions,
  analyticsType,
  onChange,
}: Props) => {
  return (
    <Popover className="relative">
      <PopoverButton
        as={Button}
        className="w-full whitespace-nowrap"
        variant="secondary"
        color="white"
        size="normal"
        onClick={() => {}}
        icon={<ChartBarIcon className="h-4 w-4" />}
      >
        Breakdown{analyticsType ? ` / ${capitalize(analyticsType)}` : ''}
      </PopoverButton>
      <PopoverPanel
        transition
        anchor="bottom end"
        modal
        className="z-10 transition duration-200 ease-in-out data-[closed]:translate-y-1 data-[closed]:opacity-0"
      >
        <div className="absolute right-0 z-20 ml-[1.2rem] mr-3.5 mt-0.5 h-4 w-4 rotate-45 border-l border-t border-gray-300 bg-white dark:border-slate-600 dark:bg-slate-800"></div>
        <div className="mt-2.5 rounded-lg border border-gray-300 bg-white p-3 shadow-sm">
          <div className="relative flex flex-col gap-4">
            {analyticsTypeOptions.map((option) => {
              const selected = analyticsType === option;

              return (
                <Button
                  key={option}
                  variant={selected ? 'primary' : 'secondary'}
                  className="justify-start pe-9"
                  onClick={() => {
                    onChange(option);
                  }}
                >
                  <CheckIcon
                    className={classNames(
                      'absolute right-2 h-4 w-4',
                      selected ? 'visible' : 'invisible',
                    )}
                  />
                  {capitalize(option || 'None')}
                </Button>
              );
            })}
          </div>
        </div>
      </PopoverPanel>
    </Popover>
  );
};
